import Alpine from 'alpinejs';
import simpleParallax from 'simple-parallax-js';

Alpine.data('parallax', () => ({
    init() {
        new simpleParallax(this.$root, {
            scale: 1.5,
            delay: 0.6,
            transition: 'cubic-bezier(0,0,0,1)',
        });
    },
}));
